import React from 'react';
import { AuthCard } from './Login';
import { useLang } from '../context/LanguageContext';
import { translations } from '../mock';

export default function AdminLogin() {
  const { t } = useLang();
  return <AuthCard role="admin" title={t(translations.auth.adminLogin)} redirect="/admin/dashboard" />;
}
